import React, { useEffect, useState } from "react";
import DashboardShell from "../../components/DashboardShell";
import { api } from "../../lib/api";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

const statusColor = { high: "text-red-400", medium: "text-amber-400", low: "text-emerald-400" };

export default function Drift() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/v1/drift").then(r => setD(r.data)); }, []);

  return (
    <DashboardShell title="Drift Detection" subtitle="Behavioral drift across the last 24h vs the prior 24h window.">
      {!d ? <div className="text-cream/50">Loading…</div> : (
        <div className="space-y-4">
          <div className="grid md:grid-cols-2 gap-4">
            <div className="rounded-xl bg-white/5 border border-white/10 p-5">
              <div className="eyebrow text-[#FFD98A]" style={{fontSize:10}}>CURRENT WINDOW</div>
              <div className="font-display text-3xl font-bold mt-2">{d.current_count}<span className="text-lg text-cream/50"> decisions</span></div>
              <div className="text-xs text-cream/50">last 24h</div>
            </div>
            <div className="rounded-xl bg-white/5 border border-white/10 p-5">
              <div className="eyebrow text-[#FFD98A]" style={{fontSize:10}}>PREVIOUS WINDOW</div>
              <div className="font-display text-3xl font-bold mt-2">{d.previous_count}<span className="text-lg text-cream/50"> decisions</span></div>
              <div className="text-xs text-cream/50">24–48h ago</div>
            </div>
          </div>
          <div className="rounded-xl bg-white/5 border border-white/10 overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-white/5 text-cream/60">
                <tr className="text-left">
                  <th className="px-4 py-3 eyebrow" style={{fontSize:10}}>Metric</th>
                  <th className="px-4 py-3 eyebrow" style={{fontSize:10}}>Current</th>
                  <th className="px-4 py-3 eyebrow" style={{fontSize:10}}>Previous</th>
                  <th className="px-4 py-3 eyebrow" style={{fontSize:10}}>Δ</th>
                  <th className="px-4 py-3 eyebrow" style={{fontSize:10}}>Change</th>
                  <th className="px-4 py-3 eyebrow" style={{fontSize:10}}>Signal</th>
                </tr>
              </thead>
              <tbody>
                {d.metrics.map(m => {
                  const Icon = m.pct_change > 0.5 ? TrendingUp : m.pct_change < -0.5 ? TrendingDown : Minus;
                  return (
                    <tr key={m.metric} data-testid={`drift-${m.metric.replace(/[^a-z0-9]+/gi,'-').toLowerCase()}`} className="border-t border-white/5">
                      <td className="px-4 py-3 font-semibold">{m.metric}</td>
                      <td className="px-4 py-3 font-mono">{m.current}</td>
                      <td className="px-4 py-3 font-mono text-cream/60">{m.previous}</td>
                      <td className="px-4 py-3 font-mono">{m.delta}</td>
                      <td className={`px-4 py-3 font-mono flex items-center gap-1.5 ${statusColor[m.status]}`}>
                        <Icon size={14}/> {m.pct_change}%
                      </td>
                      <td className="px-4 py-3">
                        <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded-full border ${
                          m.status === "high" ? "border-red-500/40 bg-red-500/10 text-red-300" :
                          m.status === "medium" ? "border-amber-500/40 bg-amber-500/10 text-amber-300" :
                          "border-emerald-500/40 bg-emerald-500/10 text-emerald-300"
                        }`}>{m.status}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="rounded-xl bg-white/5 border border-white/10 p-5">
              <div className="eyebrow text-[#FFD98A] mb-3" style={{fontSize:10}}>MODEL MIX · CURRENT</div>
              {Object.entries(d.current_model_dist).map(([k,v]) => (
                <div key={k} className="flex justify-between py-1.5 text-sm border-b border-white/5 last:border-0">
                  <span className="font-mono text-cream/85">{k}</span><span className="text-cream/50">{v}</span>
                </div>
              ))}
            </div>
            <div className="rounded-xl bg-white/5 border border-white/10 p-5">
              <div className="eyebrow text-[#FFD98A] mb-3" style={{fontSize:10}}>MODEL MIX · PREVIOUS</div>
              {Object.entries(d.previous_model_dist).map(([k,v]) => (
                <div key={k} className="flex justify-between py-1.5 text-sm border-b border-white/5 last:border-0">
                  <span className="font-mono text-cream/85">{k}</span><span className="text-cream/50">{v}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </DashboardShell>
  );
}
